import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { UtilService } from '../../../../../shared/_services/util.service';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { Subject } from 'rxjs';
import { EmployeeService } from '../../../../../shared/_services/employee.service';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss']
})
export class BenefitsComponent implements OnInit {

  statusModal: BsModalRef;
  activateAction: boolean;
  allBenefitsSelected: any;
  benefitsList: any[];
  selectedBenefits: any[] = [];
  p: number = 0;
  size: number = 10;
  totalCount: any;

  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private modalService: BsModalService,
    private utilService: UtilService,
    private employeeService: EmployeeService
  ) { 
    this.modalService.onHide
    .takeUntil(this.unsubscribe)
    .subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action == "action1") {
          if (this.statusModal.content.srcObject.type == "member-edit") {
            if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
              let status = +this.statusModal.content.srcObject.status;
              this.activateOrDeactivateBenefit(this.statusModal.content.srcObject.id, status);
            } else {
              // this.router.navigate(['/members']);
            }
          }
        }
      }
    })
  }

  activateOrDeactivateBenefit(benefitIds, status) {
    this.employeeService.activateOrDeactivateBenefit(benefitIds, status).subscribe(res => {
      if(res.error == 0) {
        this.getBenefitsList(this.p > 0 ? this.p - 1 : this.p);
        this.allBenefitsSelected = false;
        this.selectBenefits('all');
      }
    }, err => {
      console.error('Error Activating/Deactivating Benefits: ', err.message);
    }) 
  }

  getBenefitsList(page) {
    this.employeeService.getBenefitsList(page).subscribe(res => {
      if (res.error == 0) {
        this.benefitsList = res.responseObj.results;
        this.totalCount = res.responseObj.totalRecords;
      }
    }, err => {
      console.error('Error while fetching all benefits: ', err.message);
    });
  }

  pageChanged($event) {
    let page = $event - 1;
    this.getBenefitsList(page);
    this.allBenefitsSelected = false;
    this.selectBenefits('all');
    this.p = $event;
  }

  get getSelectedBenefits() {
    return this.utilService.cleanArray(this.benefitsList.map(benefit => {
      if (benefit.checked) {
        this.activateAction = true;
        return benefit.benefitId;
      } else {
        this.activateAction = false;
        return null;
      }
    }))
  }

  selectBenefits(type) {
    if(type == 'all'){
      for (var i = 0; i < this.benefitsList.length; i++) {
        this.benefitsList[i].checked = this.allBenefitsSelected;
      }
    } else {
      this.allBenefitsSelected = this.benefitsList.every(function (item: any) {
        return item.checked == true;
      })
    }
    this.selectedBenefits = this.getSelectedBenefits;
  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = mode == 0 ? "Are you sure you want to deactivate this Benefit(s)?" : "Are you sure you want to activate this Benefit(s)?";
    let title = mode == 0 ? "Deactivate Benefit" : "Activate Benefit";
    let action1 = mode == 0 ? "Deactivate" : "Activate";
    let style = mode == 0 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'member-edit',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }

  ngOnInit() {
    this.getBenefitsList(0);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/benefits/benefits.component.ts